import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { WalletProvider } from './contexts/WalletContext';
import { TreasuryProvider } from './contexts/TreasuryContext';
import { GovernanceProvider } from './contexts/GovernanceContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { RealTimeDataProvider } from './contexts/RealTimeDataContext';
import { VerificationProvider } from './contexts/VerificationContext';
import { SettingsProvider } from './contexts/SettingsContext';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingSpinner from './components/LoadingSpinner';
import ErrorBoundary from './components/ErrorBoundary';
import RealTimeDataDisplay from './components/RealTimeDataDisplay';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import AdminVerification from './pages/AdminVerification';
import HorseCollection from './pages/HorseCollection';
import Governance from './pages/Governance';
import Treasury from './pages/Treasury';
import Settings from './pages/Settings';
import Analytics from './pages/Analytics';
import AuthPage from './pages/AuthPage';
import NotFound from './pages/NotFound';

// Styles
import './index.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Simulate app initialization
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

        return (
          <ErrorBoundary>
            <WalletProvider>
              <TreasuryProvider>
                <GovernanceProvider>
                  <NotificationProvider>
                    <RealTimeDataProvider>
                      <VerificationProvider>
                        <SettingsProvider>
                          <Router>
                        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
                          <Navbar user={user} setUser={setUser} />
                          
                          <main className="relative">
                                 <Routes>
                                   {/* Public Routes */}
                                   <Route path="/" element={<HomePage />} />
                                   <Route path="/about" element={<AboutPage />} />
                                   <Route path="/auth" element={<AuthPage setUser={setUser} />} />
                              
                              {/* User Routes */}
                              <Route path="/dashboard" element={<UserDashboard />} />
                              <Route path="/horses" element={<HorseCollection />} />
                              <Route path="/governance" element={<Governance />} />
                              <Route path="/treasury" element={<Treasury />} />
                              <Route path="/settings" element={<Settings />} />
                              <Route path="/analytics" element={<Analytics />} />
                              
                              {/* Admin Routes */}
                              <Route path="/admin" element={<AdminDashboard />} />
                              <Route path="/admin/verify" element={<AdminVerification />} />
                              
                              {/* 404 */}
                              <Route path="*" element={<NotFound />} />
                            </Routes>
                          </main>
                          
                          <Footer />
                          <RealTimeDataDisplay />
                        </div>
                          </Router>
                        </SettingsProvider>
                      </VerificationProvider>
                    </RealTimeDataProvider>
                  </NotificationProvider>
                </GovernanceProvider>
              </TreasuryProvider>
            </WalletProvider>
          </ErrorBoundary>
        );
}

export default App;
